import * as React from "react";
import { Card, CardActions, CardContent, Grid } from "@mui/material";
import { BasicAccountApplicationItemClassNameBase } from "../types";
import { BasicAccountApplicationAppliedItemProps } from "./types";
import CustomTypography from "../../typography";
import Icon from "../../../../ui/widgets/icons";
import "../styles.scss";

const classNameBase =
  "status-applied " + BasicAccountApplicationItemClassNameBase;

export default function BasicAccountApplicationAppliedItem(
  props: BasicAccountApplicationAppliedItemProps,
): React.JSX.Element {
  const {
    product,
    image,
    title,
    text,
    pdfLink,
    signature,
    invoicingType,
    insurancePlus,
    cardActionsItem,
  } = props;

  return (
    <Card className={`${classNameBase}`} color={product}>
      <CardContent className={`${classNameBase}-content`} component="div">
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <div className="scd-app-item-wrapper">
              <div className="scd-account-application-item-image">
                {image}
                {insurancePlus && (
                  <CustomTypography className="item-insurance" variant="body2">
                    {insurancePlus}
                  </CustomTypography>
                )}
              </div>
              <div className="scd-account-application-item-info">
                <CustomTypography className="item-title" variant="h4">
                  {title}
                </CustomTypography>
                <CustomTypography className="item-description" variant="body2">
                  <Icon icon="icon-scd-check" />
                  <span className="item-text">{text}</span>
                </CustomTypography>
                <CustomTypography className="item-link-pdf" variant="body2">
                  <Icon icon="icon-scd-pdf" />
                  <span className="item-text">{pdfLink}</span>
                </CustomTypography>
                <CustomTypography className="item-signature" variant="body2">
                  {signature}
                </CustomTypography>
                {invoicingType && (
                  <CustomTypography className="item-invoicing" variant="body2">
                    {invoicingType}
                  </CustomTypography>
                )}
              </div>
            </div>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <CardActions className={`${classNameBase}-actions`}>
              {cardActionsItem}
            </CardActions>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
